"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectLayerStore = void 0;
var debug_1 = require("../debug");
/**
 * Stores and manages one or more sub-canvas layers for an object. All layers automatically
 * match the current size of the object. If the size of the object has changed since the
 * last time it was rendered, all layers are cleared and resized.
 *
 * Refer to {@see PipelineState.updateSubcanvas} for more info.
 */
var ObjectLayerStore = /** @class */ (function () {
    function ObjectLayerStore(device) {
        this.device = device;
        this._childrenByName = {};
        this._size = { width: 0, height: 0 };
        this.result = this.device.createLayer();
        if (debug_1.debug.ADD_SUBCANVASES_TO_DOM) {
            document.body.appendChild(this.result.canvas);
            this.result.canvas.style.border = "1px dotted red";
        }
    }
    /**
     * Updates the object size. If width/height has changed, all layers will be cleared.
     *
     * @param size The target size.
     */
    ObjectLayerStore.prototype.resizeTo = function (size) {
        var e_1, _a;
        this._size = size;
        this.result.resizeTo(size);
        try {
            for (var _b = __values(Object.keys(this._childrenByName)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var name_1 = _c.value;
                this._childrenByName[name_1].resizeTo(size);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * Draws a sub-canvas layer onto another layer.
     *
     * @param name The name identifying the source layer.
     * @param ctx The rendering context of the target layer.
     */
    ObjectLayerStore.prototype.composite = function (name, ctx) {
        if (!this._childrenByName[name]) {
            throw new Error("No sub-layer named \"" + name + "\".");
        }
        this._childrenByName[name].drawOn(ctx);
    };
    /**
     * Gets a sub-canvas layer that may later be painted onto {@link result} by the caller.
     *
     * @param name The name identifying the layer.
     * @param canvasType Type for the child canvas
     */
    ObjectLayerStore.prototype.child = function (name, canvasType) {
        if (canvasType === void 0) { canvasType = "auto"; }
        var layer = this._childrenByName[name];
        if (!layer) {
            layer = this.device.createLayer(canvasType);
            this._childrenByName[name] = layer;
            layer.resizeTo(this._size);
        }
        return layer;
    };
    return ObjectLayerStore;
}());
exports.ObjectLayerStore = ObjectLayerStore;
//# sourceMappingURL=ObjectLayerStore.js.map